import { useCallback } from 'react';

import * as server from '../server';

export const useGetPaymentStatistics = () => {
    return useCallback(async () => {
        const response = await server.getPaymentStatistics();

        return response?.data?.payments?.statistics ?? {};
    }, []);
};
